<template>
    <div v-if="exists && !loading" class="d-flex flex-column" :class="{'flex-column-reverse': unsubscribe}">
        <div v-if="showAddressGrid" class="address-grid">
            <b-form-group :label="$t('account.details.form.name')">
                <span>{{ member.first_name }} {{ member.last_name }}</span>
            </b-form-group>
            <b-form-group :label="$t('account.details.form.street')">
                <span>{{ member.street }}</span>
                <div>{{ member.care_of }}</div>
            </b-form-group>
            <b-form-group :label="$t('account.details.form.city')">
                <span>{{ member.city }}</span>
            </b-form-group>
            <b-form-group :label="$t('account.details.form.zipCode')">
                <span>{{ member.zip_code }}</span>
            </b-form-group>
            <b-form-group :label="$t('account.details.form.email')">
                <span>{{ member.email }}</span>
            </b-form-group>
            <b-form-group :label="$t('account.details.form.phone')">
                <span>{{ member.mobile_phone }}</span>
            </b-form-group>
        </div>
        <accordion
            id="acc-info"
            :title="$t('members.profileEditor.accordionInfoTitle')"
            class="mb-4"
            :visible="!unsubscribe"
        >
            <b-form @submit.stop.prevent="fetch">
                <b-row>
                    <b-col>
                        <b-form-group
                            :label="$t('members.profileEditor.firstNameLabel')"
                            label-for="input-firstname"
                        >
                            <b-form-input
                                id="input-firstname"
                                v-model="member.first_name"
                                type="text"
                                :placeholder="$t('members.profileEditor.firstNamePlaceholder')"
                                required
                                :disabled="loading_info"
                                :state="(errors['first_name'] && errors['first_name'][0]) ? false : null"
                                @input="resetError('first_name')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="(errors['first_name'] && errors['first_name'][0])">{{ errors['first_name'][0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            :label="$t('members.profileEditor.lastNameLabel')"
                            label-for="input-lastname"
                        >
                            <b-form-input
                                id="input-lastname"
                                v-model="member.last_name"
                                type="text"
                                :placeholder="$t('members.profileEditor.lastNamePlaceholder')"
                                required
                                :disabled="loading_info"
                                :state="(errors['last_name'] && errors['last_name'][0]) ? false : null"
                                @input="resetError('last_name')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="(errors['last_name'] && errors['last_name'][0])">{{ errors['last_name'][0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-form-group
                    :label="$t('members.profileEditor.streetLabel')"
                    label-for="input-street"
                >
                    <b-form-input
                        id="input-street"
                        v-model="member.street"
                        type="text"
                        :placeholder="$t('members.profileEditor.streetPlaceholder')"
                        required
                        :disabled="loading_info"
                        :state="(errors['street'] && errors['street'][0]) ? false : null"
                        @input="resetError('street')"
                    ></b-form-input>

                    <b-form-invalid-feedback v-if="(errors['street'] && errors['street'][0])">{{ errors['street'][0] }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    :label="$t('members.profileEditor.careOfLabel')"
                    label-for="input-street"
                >
                    <b-form-input
                        id="input-careof"
                        v-model="member.care_of"
                        type="text"
                        :placeholder="$t('members.profileEditor.careOfPlaceholder')"
                        required
                        :disabled="loading_info"
                        :state="(errors['care_of'] && errors['care_of'][0]) ? false : null"
                        @input="resetError('care_of')"
                    ></b-form-input>

                    <b-form-invalid-feedback v-if="(errors['care_of'] && errors['care_of'][0])">{{ errors['care_of'][0] }}</b-form-invalid-feedback>
                </b-form-group>
                <b-row>
                    <b-col cols="4">
                        <b-form-group
                            :label="$t('members.profileEditor.zipCodeLabel')"
                            label-for="input-zipcode"
                        >
                            <b-form-input
                                id="input-zipcode"
                                v-model="member.zip_code"
                                type="text"
                                :placeholder="$t('members.profileEditor.zipCodePlaceholder')"
                                required
                                :disabled="loading_info"
                                :state="(errors['zip_code'] && errors['zip_code'][0]) ? false : null"
                                @input="resetError('zip_code')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="(errors['zip_code'] && errors['zip_code'][0])">{{ errors['zip_code'][0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col cols="8">
                        <b-form-group
                            :label="$t('members.profileEditor.cityLabel')"
                            label-for="input-city"
                        >
                            <b-form-input
                                id="input-city"
                                v-model="member.city"
                                type="text"
                                :placeholder="$t('members.profileEditor.cityPlaceholder')"
                                required
                                :disabled="loading_info"
                                :state="(errors['city'] && errors['city'][0]) ? false : null"
                                @input="resetError('city')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="(errors['city'] && errors['city'][0])">{{ errors['city'][0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-form-group
                    :label="$t('members.profileEditor.emailLabel')"
                    label-for="input-email"
                >
                    <b-form-input
                        id="input-email"
                        v-model="member.email"
                        type="email"
                        :placeholder="$t('members.profileEditor.emailPlaceholder')"
                        required
                        disabled
                        readonly
                        :state="(errors['email'] && errors['email'][0]) ? false : null"
                        @input="resetError('email')"
                    ></b-form-input>

                    <b-form-invalid-feedback v-if="(errors['email'] && errors['email'][0])">{{ errors['email'][0] }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    :label="$t('members.profileEditor.mobilePhoneLabel')"
                    label-for="input-mobilephone"
                >
                    <b-form-input
                        id="input-mobilephone"
                        v-model="member.mobile_phone"
                        type="text"
                        :placeholder="$t('members.profileEditor.mobilePhonePlaceholder')"
                        required
                        :disabled="loading_info"
                        :state="(errors['mobile_phone'] && errors['mobile_phone'][0]) ? false : null"
                        @input="resetError('mobile_phone')"
                    ></b-form-input>

                    <b-form-invalid-feedback v-if="(errors['mobile_phone'] && errors['mobile_phone'][0])">{{ errors['mobile_phone'][0] }}</b-form-invalid-feedback>
                </b-form-group>

                <div v-if="!member.social_security_number">
                    <b-form-group
                        id="input-birthday"
                        :label="$t('members.profileEditor.birthDayLabel')"
                        :state="(errors['birth_day'] && errors['birth_day'][0]) ? false : null"
                        @input="resetError('birth_day')"
                    >
                        <my-date-field v-model="member.birth_day"></my-date-field>
                    </b-form-group>

                    <b-form-invalid-feedback v-if="(errors['birth_day'] && errors['birth_day'][0])">{{ errors['birth_day'][0] }}</b-form-invalid-feedback>
                </div>

                <div class="text-right">
                    <b-button variant="primary" @click="update('info')" :disabled="loading_info" class="btn-action mt-3">
                        <b-spinner v-if="loading_info" label="Loading..." small class="mr-2"></b-spinner>
                        <b-icon-check2 v-else-if="success_info"></b-icon-check2>
                        <span v-if="loading_info">{{ $t('members.profileEditor.saveButtonLoading') }}</span>
                        <span v-else-if="success_info">{{ $t('members.profileEditor.saveButtonSaved') }}</span>
                        <span v-else>{{ $t('members.profileEditor.saveButton') }}</span>
                    </b-button>
                </div>
            </b-form>
        </accordion>
        <accordion
            id="acc-mail"
            :title="$t('members.profileEditor.accordionMailTitle')"
            :visible="unsubscribe"
            class="mb-4"
        >
            <b-form @submit.stop.prevent="fetch">
                <section class="communication-section">
                    <b-form-group :label="$t('members.profileEditor.communicationFrequency')">
                        <b-form-radio v-model="member.email_frequency" name="input-emailfrequency" :value="2" class="mt-2" :disabled="loading_mail">
                            <div class="font-weight-normal">{{ $t('members.profileEditor.emailFrequencyNormalLabel') }}</div>
                            <div class="small font-weight-lighter">{{ $t('members.profileEditor.emailFrequencyNormalDesc') }}</div>
                        </b-form-radio>
                        <b-form-radio v-model="member.email_frequency" name="input-emailfrequency" :value="1" class="mt-3" :disabled="loading_mail">
                            <div class="font-weight-normal">{{ $t('members.profileEditor.emailFrequencySlowLabel') }}</div>
                            <div class="small font-weight-lighter">{{ $t('members.profileEditor.emailFrequencySlowDesc') }}</div>
                        </b-form-radio>
                    </b-form-group>

                    <b-form-group :label="$t('members.profileEditor.communication')" v-slot="{ ariaDescribedby }">
                        <b-checkbox v-model="member.contact_preferences_accepts_email" :value="true" :unchecked-value="false">
                            {{ $t('members.profileEditor.emailCheckboxLabel') }}
                        </b-checkbox>
                        <b-checkbox v-model="member.contact_preferences_accepts_sms" :value="true" :unchecked-value="false">
                            SMS
                        </b-checkbox>
                    </b-form-group>
                </section>

                <div class="text-right">
                    <b-button variant="primary" @click="update('communication')" :disabled="loading_mail" class="btn-action">
                        <b-spinner v-if="loading_mail" label="Loading..." small class="mr-2"></b-spinner>
                        <b-icon-check2 v-else-if="success_mail"></b-icon-check2>
                        <span v-if="loading_mail">{{ $t('members.profileEditor.saveButtonLoading') }}</span>
                        <span v-else-if="success_mail">{{ $t('members.profileEditor.saveButtonSaved') }}</span>
                        <span v-else>{{ $t('members.profileEditor.saveButton') }}</span>
                    </b-button>
                </div>
            </b-form>
        </accordion>
    </div>
    <b-skeleton v-else-if="loading" height="180px"></b-skeleton>
    <b-card v-else no-body class="py-4 px-md-5 py-md-5 mb-5 mobile-padding">
        <div v-if="!exists && !loading">{{ $t('members.profileEditor.memberNotFoundMessage') }}</div>
        <div v-else-if="error">{{ $t('members.profileEditor.errorMessage') }}</div>
    </b-card>
</template>
<script>
import Accordion from "@components/Accordion.vue";
import HttpClient from "@services/HttpClient";
import { reactive, unref } from 'vue';
import { useUserStore } from '@stores/User';
import MyDateField from '@components/Form/MyDateField.vue';

export default {
    components: {
        MyDateField,
        Accordion,
        HttpClient
    },
    props: {
        voyadoId: {
            type: Number,
            default: null,
        },
        encrypted: {
            type: String,
            default: null,
        },
        unsubscribe: {
            type: Boolean,
            default: false,
        },
        showAddressGrid: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            success_info: false,
            loading_info: false,
            loading_mail: false,
            success_mail: false,
            exists: false,
            encrypted: null,
            message_id: null,
            error: false,
            errors: [],
            member: {
                short_member_id: null,
                social_security_number: null,
                first_name: null,
                last_name: null,
                street: null,
                care_of: null,
                zip_code: null,
                city: null,
                email: null,
                mobile_phone: null,
                email_frequency: null,
                contact_preferences_accepts_email: null,
                contact_preferences_accepts_sms: null,
            }
        };
    },
    mounted() {
        console.log('mounted');
        this.fetch();
    },
    watch: {
        success_info(value) {
            if (value) {
                setTimeout(() => {
                    this.success_info = false;
                }, 2000);
            }
        },
        success_mail(value) {
            if (value) {
                setTimeout(() => {
                    this.success_mail = false;
                }, 2000);
            }
        }
    },
    computed: {
        isLoggedIn() {
            const user = useUserStore();
            return user.isLoggedIn();
        },
    },
    methods: {
        async fetch() {
            let url = 'member/v/' + this.voyadoId;
            if (this.encrypted) {
                url += '?' + new URLSearchParams({ encrypted: this.encrypted });
            }

            const response = await HttpClient.getData(url);

            if (response.status === 404) {
                this.exists = false;
                this.loading = false;

                return;
            }

            if (response.status !== 200) {
                this.exists = false;
                this.loading = false;
                this.error = true;

                return;
            }

            const responseData = await response.json();
            this.member = reactive({
                ...this.member,
                ...responseData,
            });

            this.exists = true;
            this.loading = false;
            this.error = false;
        },
        async update(type) {
            this['loading_' + type] = true;
            if (type === 'communication' && this.message_id && this.member.email_frequency === 0) {
                await HttpClient.postData('member/v/' + this.member.short_member_id + '/unsubscribe-email/' + this.message_id);
            }
            const response = await HttpClient.postData('member/v/' + this.member.short_member_id + '/' + type, this.member);

            if (response.status === 404) {
                this.exists = false;

                return;
            }

            if (response.status === 422) {
                const responseData = await response.json();
                if (responseData.errorCode) {
                    // errorCode comes from Voyado, not from our validation.
                    this.exists = false;
                    this.error = true;

                    return;
                }
                if (responseData.errors) {
                    this.errors = responseData.errors;
                }
                this.loading = false;
                this.loading_mail = false;
                this.loading_info = false;

                return;
            }

            if (response.status !== 200) {
                this.exists = false;
                this.error = true;

                return;
            }

            const responseData = await response.json();

            this.member = reactive({
                ...this.member,
                ...responseData,
            });

            this.exists = true;
            this.error = false;
            this.errors = [];
            this.loading = false;
            this.loading_mail = false;
            this.loading_info = false;
            this['success_' + type] = true;
        },
        resetError(field) {
            this.errors[field] = [];
        },
    },
};
</script>
<style scoped>
.address-grid {
    margin: 1rem 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    .sm & {
        grid-template-columns: repeat(2, 1fr);
    }

    ::v-deep .col-form-label {
        font-weight: 500;
    }

    ::v-deep .form-group {
        font-weight: 300;
    }
}

.communication-section {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
}

.loading-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0);

    display: flex;
    justify-content: center;
    align-items: center;
    animation: fadeIn 0.3s forwards;
}
</style>
